import { render } from "./ConfiguracaoStatus.vue?vue&type=template&id=5a1669c4&scoped=true"
import script from "./ConfiguracaoStatus.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoStatus.vue?vue&type=script&lang=js"

import "./ConfiguracaoStatus.vue?vue&type=style&index=0&id=5a1669c4&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a1669c4"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QInput,QIcon,QLinearProgress,QTable,QCard,QTr,QTh,QTd,QPagination});
